(function($) {
	/*jshint validthis:true */
	"use strict";
    var selectedChapters;

    function updateSelectedChapters(){
        var input = $(this);
        var val = input.val();
        var newVal = "";
        var add = true;
        if(!input.is(":checked")){
            add = false;
        }
        
        if(!add){
            var newValArr = selectedChapters.val().split("-");
            var index = newValArr.findIndex(function (v) {
                return v === val;
            });
            newValArr.splice(index, 1);
            newVal = newValArr.join("-");
        } else {
            newVal = selectedChapters.val() + val + "-";
        }
        
        selectedChapters.val(newVal);
    }
    
    function saveArticleDate(e) {
        var $btn = $(e ? e.currentTarget || e.target : this);
        var $form = $btn.closest("form");
        var $inp = $form.find(".article-date-picker");
        var $status = $form.find(".processing-status");
        var date = $inp.val().trim();
        
        var _hideStatus = function () {
            window.articlePageProcessingTimeout = setTimeout(function() {
                $status.hide();
            }, 8000);
        };
        var _showError = function (xhr, status, errorThrown) {
            $status.text("Error").show();
            _hideStatus();
        };
        
        try {
            $status.hide();
            clearTimeout(window.articlePageProcessingTimeout);
            // Ex: 12/08/2020
            var arr = date.split(date.match("/") ? "/" : "-");
            
            $.ajax({
                type: "post",
                method: "post",
                url: "/action/crgmArticleDate",
                data: {
                    pageId: $inp.attr("data-id"),
                    createdDate: date,
                    createdDateYear: arr[2],
                    createdDateMonth: parseInt(arr[1]) - 1,
                    createdDateDay: arr[0],
                    createdDateHour: $form.find(".article-date-hour-select").val(),
                    createdDateMinute: $form.find(".article-date-minute-select").val()
                },
                success: function(data, status, xhr) {
                    if (data.match("success")) {
                        $status.text("Complete").show();
                        _hideStatus();
                    } else {
                        _showError();
                    }
                },
                error: _showError
            });
        } catch (err) {
            _showError();
        }
    }

	function init() {
        selectedChapters = $(".selected-chapters");
		$(".articles-setting-chapter input").on("click", updateSelectedChapters);
        $(".article-date-picker").datepicker();
        $(".article-date-form .default-btn").on("click", saveArticleDate);
	}
	
	$(init);
	
})(jQuery);